import Vue from 'vue'
import App from './App.vue'
import router from './modules/route';
import i18n from './locales/index'
import "./assets/css/style.scss"
import {
  plugin as VueFunctionApiPlugin
} from 'vue-function-api';
Vue.use(VueFunctionApiPlugin);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

Vue.config.productionTip = false

const app = new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
});

Vue.use({
  app
});